import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';
import httpClient from 'utils/httpClient';
import { CHAT_BACKEND_URL } from 'configs/env.conf';

export const endLiveKitClass = () =>
  httpClient.post<any>(
    '/livekit/end-class',
    {},
    {
      baseURL: CHAT_BACKEND_URL,
    },
  );

export const useEndLiveKitClass = (
  opts?: UseMutationOptions<AxiosResponse<any>, AxiosError<any>, void>,
) =>
  useMutation<AxiosResponse<any>, AxiosError<any>, void>(endLiveKitClass, opts);
